var wsjs_extra = (function () {
	"use strict";

	var cookie_name = 'wsjs_extra';
	var cookie_lifetime_minutes = 6 * 30 * 24 * 60;
	var cookie_domain = 'worksection.com';

	window.ga_adid = null;
	window.ga_matchtype = null;
	window.ga_adposition = null;
	window.ga_device = null;
	window.ga_device_model = null;
	window.ga_lang = null;
	window.ga_placement = null;
	window.ga_target = null;
	window.ga_geo = null;
	window.ga_physical_geo = null;
	window.ga_network = null;

	function get_url_params() {
		var result = {};
		if (window.location.search.length > 1) {
			var params = window.location.search.substr(1).split('&');
			for (var i = 0; i < params.length; i++) {
				var tmp = params[i].split('=');
				if (tmp.length === 2) {
					result[decodeURIComponent(tmp[0])] = decodeURIComponent(tmp[1]);
				}
			}
		}
		return result;
	}

	function get_device_model() {
		if (typeof UAParser !== 'undefined') {
			var parser = new UAParser();
			var result = parser.getDevice();
			if (result.model) return result.model;
			var type = result.type || parser.getDevice().type || parser.getOS().name;
			return type || 'unknown';
		}
		return 'unknown';
	}

	function set_cookie(name, value, lifetime_minutes) {
		if (window.localStorage) {
			localStorage.setItem(name, value);
			document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
			return;
		}
		var expires = new Date();
		expires.setTime(expires.getTime() + lifetime_minutes * 60 * 1000);
		document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + expires.toUTCString() + ";path=/;domain=." + cookie_domain;
	}

	function parse_data(params) {
		return {
			adid: params.utm_adid || params.adid || params.creative || null,
			matchtype: params.matchtype || null,
			adposition: params.adposition || null,
			device: params.utm_device || params.device || null,
			device_model: get_device_model(),
			lang: params.utm_lang || params.language || null,
			placement: params.utm_placement || params.placement || null,
			target: params.utm_target || params.target || null,
			geo: params.utm_geo || params.loc_interest_ms || null,
			physical_geo: params.utm_physical_geo || params.loc_physical_ms || null,
			network: params.utm_network || params.network || null
		};
	}

	function serialize(obj) {
		var short_keys = {
			adid: 'ad',
			matchtype: 'mt',
			adposition: 'ap',
			device: 'dv',
			device_model: 'dm',
			lang: 'lg',
			placement: 'pl',
			target: 'tg',
			geo: 'gi',
			physical_geo: 'gp',
			network: 'nw'
		};
		return Object.keys(obj)
			.filter(function (key) { return obj[key] !== null; })
			.map(function (key) {
				return short_keys[key] + '=' + encodeURIComponent(obj[key]);
			}).join('|');
	}

	function deserialize(str) {
		var long_keys = {
			ad: 'adid',
			mt: 'matchtype',
			ap: 'adposition',
			dv: 'device',
			dm: 'device_model',
			lg: 'lang',
			pl: 'placement',
			tg: 'target',
			gi: 'geo',
			gp: 'physical_geo',
			nw: 'network'
		};
		var result = {};
		str.split('|').forEach(function (pair) {
			var tmp = pair.split('=');
			if (tmp.length === 2 && long_keys[tmp[0]]) {
				result[long_keys[tmp[0]]] = decodeURIComponent(tmp[1]);
			}
		});
		return result;
	}

	function read_cookie(name) {
		let val = null;
		if (window.localStorage) {
			val = localStorage.getItem(name);
			if (val !== null) return val;
		}
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
		}
		return null;
	}

	return {
		init: function (options) {
			options = options || {};
			var params = get_url_params();
			var saved_cookie = read_cookie(cookie_name);
			var data = saved_cookie ? deserialize(saved_cookie) : parse_data(params);

			window.ga_adid = data.adid;
			window.ga_matchtype = data.matchtype;
			window.ga_adposition = data.adposition;
			window.ga_device = data.device;
			window.ga_device_model = data.device_model;
			window.ga_lang = data.lang;
			window.ga_placement = data.placement;
			window.ga_target = data.target;
			window.ga_geo = data.geo;
			window.ga_physical_geo = data.physical_geo;
			window.ga_network = data.network;

			if (!saved_cookie && Object.keys(params).length > 0) {
				set_cookie(cookie_name, serialize(data), cookie_lifetime_minutes);
			}

			if (typeof options.callback === 'function') {
				options.callback(data);
			}
		},

		get: function () {
			var raw = read_cookie(cookie_name);
			return raw ? deserialize(raw) : null;
		}
	};
})();